import LyDatepicker from './src/index.vue'

LyDatepicker.install = function (Vue) {
    Vue.component(LyDatepicker.name, LyDatepicker)
}

export default LyDatepicker



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/datepicker/index.js
// module id = null
// module chunks = 